import React, { memo, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectors, actionCreators, sliceKeys } from '../../../model';
import { useHousesData } from '../../../services/queries/houses';
import BaseCheckbox from '../../../shared/ui/BaseCheckbox';
import styles from './index.module.scss';

const { createAllCheckboxStateSelector } = selectors[sliceKeys.houses];
const { allHousesClicked } = actionCreators[sliceKeys.houses];

const Header = memo(() => {
  return (
    <li className={styles.root}>
      <h5 className={styles.title}>Все дома</h5>
      <CheckboxBlock />
    </li>
  );
});

export default Header;

function CheckboxBlock() {
  const { data: houses } = useHousesData();

  const selectState = useMemo(
    () => createAllCheckboxStateSelector(houses?.length ?? 0),
    [houses]
  );

  const state = useSelector(selectState);
  const checked = state === 'checked';

  const dispatch = useDispatch();

  const handleChange = () => {
    dispatch(allHousesClicked(houses, !checked));
  };

  return (
    <BaseCheckbox
      checked={checked}
      indeterminate={state === 'indeterminate'}
      onChange={handleChange}
    />
  );
}
